import {
    FlexAlign,
    FlexGap,
    FlexJustify,
    StackHorizontal,
    StackVertical, useTranslation
} from "@twigsby/frontend-framework";
import React from "react";

const SubAccounts = () => {
    const { t } = useTranslation();

    return (
        <StackVertical gap={FlexGap.Small}>
            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-xs'}>
                <h2 className={'mb-0'}>{t('settings.subAccounts.title')}</h2>
            </StackHorizontal>
        </StackVertical>
    )
}

export { SubAccounts }
